import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

import cn from '@/utils/cn';

import ModalOverlay from './ModalOverlay';
import * as DialogPrimitive from '@radix-ui/react-dialog';

const ModalContent = forwardRef<
  ElementRef<typeof DialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <ModalOverlay />
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <DialogPrimitive.Content
        ref={ref}
        className={cn(
          'flex max-h-[90dvh] w-full max-w-[420px] flex-col gap-5 overflow-y-auto bg-white p-6 shadow-shadow14 focus:outline-none lg:p-8',
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-bottom-[10px] data-[state=open]:slide-in-from-bottom-[10px]',
          className
        )}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </div>
  </DialogPrimitive.Portal>
));
ModalContent.displayName = DialogPrimitive.Content.displayName;

export default ModalContent;
